import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var Italic = createReactComponent("Italic", ["svg", defaultAttributes, [["line", {
  x1: "19",
  y1: "4",
  x2: "10",
  y2: "4",
  key: "1ykz7a"
}], ["line", {
  x1: "14",
  y1: "20",
  x2: "5",
  y2: "20",
  key: "1i8hhh"
}], ["line", {
  x1: "15",
  y1: "4",
  x2: "9",
  y2: "20",
  key: "1fl2dm"
}]]]);
export default Italic;